var exports = {
  "kL": "xcc377c0b--738a9c--container",
  "DD": "xcc377c0b--738a9c--title",
  "om": "xcc377c0b--738a9c--block",
  "tA": "xcc377c0b--738a9c--submit",
  "nf": "xcc377c0b--738a9c--link",
};

module.exports = exports;
